import script from "./TodoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoSection.vue?vue&type=script&setup=true&lang=js"

import "./TodoSection.vue?vue&type=style&index=0&id=106309e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-106309e3"]])

export default __exports__